/*
 * Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
 * Licensed for non-distributable use
 */
import React from 'react';
import { Typography } from '@mui/material';

function LineItem({ value, description, style, ...props }) {
  return (
    <div style={{ marginTop: '1em', marginBottom: '1em', ...style }} {...props}>
      <Typography variant="body1">
        {value == null || value === '' ? '-----' : value}
      </Typography>
      <Typography variant="overline">{description}</Typography>
    </div>
  );
}

export default LineItem;
